import { Stack, Button, Box, DialogActions, DialogTitle } from '@mui/material';
import { useCurrentDialog } from 'src/stores/dialog';
import CloseIconButton from '../CloseIconButton';

interface ConfirmDialogProps {
  title?: string;
  description?: string | React.ReactNode;
  confirmText?: string;
  denyText?: string;
  cancelText?: string;
  cancellable?: boolean;
  disabledConfirm?: boolean;
  showCloseButton?: boolean;
}

function ConfirmDialog({
  title,
  description,
  confirmText,
  denyText,
  cancelText,
  cancellable = false,
  disabledConfirm = false,
  showCloseButton = true,
}: ConfirmDialogProps) {
  const { close } = useCurrentDialog();

  return (
    <Box>
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <DialogTitle sx={{ flex: 1 }}>{title || 'Are you sure?'}</DialogTitle>
        {showCloseButton && (
          <Box sx={{ pr: 2 }}>
            <CloseIconButton
              onClick={() => close(false)}
              data-name="confirm-dialog-close-button"
            />
          </Box>
        )}
      </Box>

      <Stack sx={{ p: 3 }}>{description || 'Are you sure you want to proceed?'}</Stack>

      <DialogActions>
        <Box sx={{ flexGrow: 1 }} />

        {cancellable && (
          <Button 
            variant="text" 
            color="error" 
            onClick={() => close(null)}
            data-name="confirm-dialog-cancel-button"
          >
            {cancelText ?? 'Cancel'}
          </Button>
        )}

        <Button 
          variant="outlined" 
          color="inherit" 
          onClick={() => close(false)}
          data-name="confirm-dialog-deny-button"
        >
          {denyText ?? 'Cancel'}
        </Button>

        <Button 
          type="submit" 
          variant="contained" 
          disabled={disabledConfirm} 
          onClick={() => close(true)}
          data-name="confirm-dialog-confirm-button"
        >
          {confirmText ?? 'Confirm'}
        </Button>
      </DialogActions>
    </Box>
  );
}

export default ConfirmDialog;
